/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState } from 'react';

export default function HeroVideo() {
  const videoRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = videoRef.current;
    if (!el) return;

    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: '200px' } 
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section className="video-container">
      <video
        ref={videoRef}
        className="object-cover w-full aspect-[3/4] sm:aspect-[16/9]"
        preload="none"
        poster="/media/bodios_small.png"
        autoPlay
        muted
        playsInline
        loop
      >
        {inView && (
          <source src="/media/bodios_hero_video.mp4" type="video/mp4" />
        )}
        Таны браузер видео тоглуулахгүй байна.
      </video>
    </section>
  );
}
